export default __webpack_public_path__ + "fa09d7c0ef5d3a6e8487730798a97c01.svg";